import {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {Box, Grid} from '@chakra-ui/react';
import {RFRenderEmpty} from '@progress-fe/rf-core';
import AutoSizer from 'react-virtualized-auto-sizer';
import {TTree} from '@progress-fe/ui-kit';
import {RFMenu} from 'ui-kit';
import {TProjectDatasetModel} from 'stores/TechProcessStore';

import {DatasetTable} from './components';

interface IProps {
  height: number;
  treeCatalog: Array<TTree>;
  datasetInstance: TProjectDatasetModel;
  onSelectDatasetRowKey: (rowKey: number) => Promise<void>;
}

const RFDatasetZoneFC: FC<IProps> = ({
  height,
  datasetInstance,
  treeCatalog,
  onSelectDatasetRowKey
}) => {
  return (
    <Grid width={'100%'} gridTemplateColumns={'48px 1fr'} height={height}>
      <RFMenu height={height} />

      <Box width={'100%'} height={height}>
        <RFRenderEmpty />
      </Box>

      <Box
        overflow={'hidden'}
        position={'absolute'}
        bottom={'24px'}
        right={'24px'}
        left={'72px'}
        top={'0'}
      >
        <Box pt={'70px'}>
          <Box height={'calc(var(--height-layout) - 70px)'}>
            <AutoSizer disableWidth={false}>
              {({height: tableHeight, width: tableWidth}) => (
                <DatasetTable
                  width={tableWidth}
                  height={tableHeight - 24}
                  treeCatalog={treeCatalog}
                  datasetInstance={datasetInstance}
                  onSelectDatasetRowKey={onSelectDatasetRowKey}
                />
              )}
            </AutoSizer>
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export const RFDatasetZone = observer(RFDatasetZoneFC);
